import React, { useEffect } from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/FooterTwo";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useCategoriesStore } from "../stores/categoriesStore";
import ShippingOne from "../components/ShippingOne";
import DiscountOne from "../components/DiscountOne";

const ShopPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const setSelectedCategoryId = useCategoriesStore((state) => state.setSelectedCategoryId);
  const fetchCategories = useCategoriesStore((state) => state.fetchCategories);

  // Ensure categories are loaded
  useEffect(() => {
    fetchCategories();
  }, []);

  // Check for category parameter in URL when shop page loads
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');
    
    if (categoryParam) {
      // Set the selected category in the global store
      setSelectedCategoryId(parseInt(categoryParam, 10));
    } else {
      // Clear selected category if no category in URL
      setSelectedCategoryId(null);
    }
  }, [location.search]);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={t('common.store')} />

      {/* ShopSection */}
      <ShopSection />

      {/* DiscountOne */}
      <div className="pb-80">
        <DiscountOne />
      </div>

      {/* ShippingOne */}
      <ShippingOne />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default ShopPage;
